import { createSlice } from '@reduxjs/toolkit';

import { refresh, signIn, signOut, signUp } from 'store/thunks';
import { PayloadState, User } from 'interfaces';
import { getUser } from 'store/thunks';

interface InitialState {
  user: null | User;
  signInRequestStatus: null | PayloadState;
  signInRequestError: string;
  signUpRequestStatus: null | PayloadState;
  signUpRequestError: string;
  getUserRequestState: null | PayloadState;
  refreshRequestState: null | PayloadState;
}

export const initialState: InitialState = {
  user: null,
  signInRequestStatus: null,
  signInRequestError: '',
  signUpRequestStatus: null,
  signUpRequestError: '',
  getUserRequestState: null,
  refreshRequestState: null,
};

export const auth = createSlice({
  name: 'authSlice',
  initialState,
  reducers: {
    clearSignInRequestError: (state) => {
      state.signInRequestError = '';
    },
    clearSignUpRequestError: (state) => {
      state.signUpRequestError = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signIn.pending, (state) => {
        state.signInRequestStatus = PayloadState.pending;
        state.signInRequestError = '';
      })
      .addCase(signIn.fulfilled, (state) => {
        state.signInRequestStatus = PayloadState.fulfilled;
        state.signInRequestError = '';
      })
      .addCase(signIn.rejected, (state, action) => {
        state.signInRequestStatus = PayloadState.rejected;
        state.signInRequestError = action.payload as string;
      });
    builder
      .addCase(signUp.pending, (state) => {
        state.signUpRequestStatus = PayloadState.pending;
        state.signUpRequestError = '';
      })
      .addCase(signUp.fulfilled, (state) => {
        state.signUpRequestStatus = PayloadState.fulfilled;
        state.signUpRequestError = '';
      })
      .addCase(signUp.rejected, (state, action) => {
        state.signUpRequestStatus = PayloadState.rejected;
        state.signUpRequestError = action.payload as string;
        console.log(action);
      });
    builder
      .addCase(getUser.pending, (state) => {
        state.user = null;
        state.getUserRequestState = PayloadState.pending;
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.user = action.payload;
        state.getUserRequestState = PayloadState.fulfilled;
      })
      .addCase(getUser.rejected, (state) => {
        state.user = null;
        state.getUserRequestState = PayloadState.rejected;
      });
    builder
      .addCase(signOut.fulfilled, (state) => {
        state.user = null;
      })
      .addCase(signOut.rejected, (state) => {
        state.user = null;
      });
    builder
      .addCase(refresh.pending, (state) => {
        state.refreshRequestState = PayloadState.pending;
      })
      .addCase(refresh.fulfilled, (state) => {
        state.refreshRequestState = PayloadState.fulfilled;
      })
      .addCase(refresh.rejected, (state) => {
        state.refreshRequestState = PayloadState.rejected;
      });
  },
});

export const { clearSignInRequestError, clearSignUpRequestError } =
  auth.actions;
